import { Fragment, SetStateAction, useState } from "react";
import Logo from "../../../constant/logo";
import { Dialog, Transition } from "@headlessui/react";
import {
  Bars3Icon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  PlusCircleIcon,
  UsersIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import CategoryCheck from "../categoryCheck";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarOpen } from "../../../store/sop/actions";

const navigation = [
  { name: "Dashboard", href: "#", icon: HomeIcon, current: true },
  { name: "Team", href: "#", icon: UsersIcon, current: false },
  { name: "Projects", href: "#", icon: FolderIcon, current: false },
  { name: "Calendar", href: "#", icon: CalendarIcon, current: false },
  { name: "Documents", href: "#", icon: InboxIcon, current: false },
  { name: "Reports", href: "#", icon: ChartBarIcon, current: false },
];

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

export default function CategorySidebar({
  setpurchaseModal,
}: {
  setpurchaseModal: React.Dispatch<SetStateAction<boolean>>;
}) {
  const selector = useSelector((state: any) => state.sop);
  const dispatch = useDispatch();

  return (
    <>
      <div>
        <Transition.Root show={selector.sidebarOpen || false} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-40 md:hidden"
            onClose={() => dispatch(setSidebarOpen(false))}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 backdrop-blur-sm " />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative flex w-full   flex-1 mt-20 mx-2 flex-col rounded-t-xl shadow-2xl bg-white">
                  <div className="h-0 flex-1 overflow-y-auto  pb-4">
                    <nav className="mt-5 space-y-1 px-2">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-in-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in-out duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <div className="float-right">
                          <button
                            type="button"
                            className="ml-1 flex h-10 w-10 items-center align-middle top-10 py-4 justify-center rounded-full focus:outline-none "
                            onClick={() => dispatch(setSidebarOpen(false))}
                          >
                            <span className="sr-only">Close sidebar</span>
                            <XMarkIcon
                              className="h-6 w-6 text-tootler-grey-400 hover:text-tootler-primary-900"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                      </Transition.Child>
                      <CategoryCheck
                        setpurchaseModal={setpurchaseModal}
                      ></CategoryCheck>
                    </nav>
                    <p className="text-center text-tootler-grey-400/90 mt-10">
                      Powered by{" "}
                      <span className="text-tootler-primary-900 font-medium">
                        Tootler.ai
                      </span>
                    </p>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>

        {/* Static sidebar for desktop */}
      </div>
    </>
  );
}
